import { RestaurantCartValue } from "@/models/cart/types";
import { ScanToOrderCartItemRight } from "./scanToOrderCartItemRight";
import { ScanToOrderCartItemLeft } from "./scanToOrderCartItemLeft";
import { useRouter } from "next13-progressbar";
import { getFromLocalStorage } from "@/utils/localStorageUtils";
import { LocalStorageKey } from "@/utils/storageKeys";
import { buildScanToOrderSearchParams } from "@/utils/scanToOrderUtils";
import { ScanToOrderInfo } from "@/dto/scanToOrderInfo";
import { getPrice } from "@/utils/getPrice";
import { getItemUrl } from "@/utils/itemUrlUtils";
import { useSearchParams } from "next/navigation";
import React from "react";

export interface ScanToOrderCartItemProps {
  item: RestaurantCartValue;
  index: number;
  // eslint-disable-next-line no-unused-vars
  removeFromCart?: (event: React.MouseEvent, index: number) => void;
  onRequestClose: () => void;
  isAlreadySentToKitchen?: boolean;
}
export const ScanToOrderCartItem = ({
  item,
  index,
  removeFromCart,
  onRequestClose,
  isAlreadySentToKitchen,
}: ScanToOrderCartItemProps) => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const menuName = searchParams?.get("menu");
  const scanToOrderInfo = getFromLocalStorage<ScanToOrderInfo | null>(
    LocalStorageKey.SCAN_TO_ORDER_INFO,
    null
  );
  const handleItemClick = () => {
    if (isAlreadySentToKitchen) return;
    let queryParams = "";
    if (scanToOrderInfo) {
      queryParams = buildScanToOrderSearchParams(scanToOrderInfo);
    }
    if (menuName) {
      queryParams += "&menu=" + menuName;
    }
    queryParams += "&cartId=" + item.cartId;
    router.push(`/menu/${getItemUrl(item)}` + queryParams);
    onRequestClose();
  };

  const calculatedItemPrice = getPrice({
    item,
    itemModifiers: item.modifiers,
    quantity: item.quantity,
  });

  return (
    <div
      key={index}
      tabIndex={isAlreadySentToKitchen ? -1 : 0}
      aria-disabled={isAlreadySentToKitchen}
      className={`w-full flex flex-col justify-between py-4 border-b ${
        !isAlreadySentToKitchen ? "cursor-pointer" : "cursor-not-allowed"
      }`}
    >
      <div className="w-full flex flex-row items-start">
        <ScanToOrderCartItemLeft
          name={item?.name}
          quantity={item?.quantity}
          isAgeRestricted={item?.isAgeRestricted}
          modifiers={item?.modifiers}
          specialInstructions={item.specialInstructions}
          onTileClick={handleItemClick}
          isAlreadySentToKitchen={isAlreadySentToKitchen}
        />
        <ScanToOrderCartItemRight
          index={index}
          price={isAlreadySentToKitchen ? item?.price : calculatedItemPrice}
          removeFromCart={removeFromCart}
          itemName={item.name}
        />
      </div>
    </div>
  );
};
